import { gql } from "@apollo/client";

const PUBLIC_RATE_LINE_FIELDS = gql`
    fragment PublicRateLineFields on PublicRateLine {
        chargeType
        carrier
        carrierLabel
        unit
        amountMinor
        currency
        account
    }
`;

/** List prices for usage. Public — the pricing page renders before sign-in. */
export const GET_PUBLIC_RATE_CARD = gql`
    ${PUBLIC_RATE_LINE_FIELDS}
    query PublicRateCard($currency: String) {
        publicRateCard(currency: $currency) {
            currency
            voice {
                ...PublicRateLineFields
            }
            committedVoice {
                perMinuteMinor
                minMonthlyMinutes
            }
            callCentre {
                ...PublicRateLineFields
            }
            sms {
                ...PublicRateLineFields
            }
            credits {
                chargeType
                unit
                credits
            }
            billing {
                collection
                voiceAutoChargeAtMinor
                callCentreAutoChargeAtMinor
                smsAutoChargeAtMinor
                minimumChargeMinor
            }
        }
    }
`;
